import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import './nominations-page.css';
import { formatDateTime } from '../../../util/dates';
import { OutputCell } from '../../common/Output';
import { getLinkUrlByNominationType } from '../../../util/links-util';

function CellItem(props) {
    const { label, dateVal, text } = props;
    const cellText = dateVal ? `до ${formatDateTime(dateVal)}` : text;
    return <OutputCell label={label} text={cellText} />;
}

function RulesLink(props) {
    const { nomination, className } = props;
    const url = getLinkUrlByNominationType(nomination.type);
    return url ? (
        <a href={`${url}`} target="_blank" rel="noreferrer" className={className + ' btn btn-link'}>
            правила
        </a>
    ) : null;
}

function NominationName(props) {
    const { nomination, category } = props;
    return (
        <div className="align-middle">
            <span>{nomination.name}</span>
            {category.name === 'Иное' && getLinkUrlByNominationType(nomination.type) && (
                <>
                    <span> - </span>
                    <RulesLink nomination={nomination} className="p-0 align-baseline" />
                </>
            )}
        </div>
    );
}

function NominationsPage(props) {
    const { categories } = props;
    return (
        <Container className="py-5">
            {categories ? (
                categories.map((category) =>
                    category.nominations && category.nominations.length ? (
                        <Card className="mx-auto mb-3" key={category.id}>
                            <Card.Header>
                                <Card.Title className="d-flex align-items-center">
                                    {category.name}
                                    {category.name !== 'Иное' &&
                                        category.nominations &&
                                        category.nominations.length && (
                                            <RulesLink nomination={category.nominations[0]} className="ml-2" />
                                        )}
                                </Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <Row className="d-none d-sm-flex mb-2 font-weight-bold">
                                    <Col sm={3}>Номинация</Col>
                                    <Col sm={3}>Прием заявок</Col>
                                    <Col sm={3}>Прием материалов</Col>
                                    <Col sm={3} />
                                </Row>
                                {category.nominations.map((nomination) => (
                                    <Row className="mb-2 pt-2 border-top" key={nomination.id}>
                                        <Col xs={12} sm={3}>
                                            <CellItem
                                                label="номинация"
                                                text={<NominationName nomination={nomination} category={category} />}
                                            />
                                        </Col>
                                        <Col xs={12} sm={3}>
                                            <CellItem label="прием заявок" dateVal={nomination.regCloseDate} />
                                        </Col>
                                        <Col xs={12} sm={3}>
                                            <CellItem label="прием материалов" dateVal={nomination.changeStopDate} />
                                        </Col>
                                        <Col xs={12} sm={3}>
                                            {dayjs().isBefore(nomination.regOpenDate) ? (
                                                <span className="font-italic">
                                                    Прием заявок откроется {formatDateTime(nomination.regOpenDate)}
                                                </span>
                                            ) : dayjs().isAfter(nomination.regCloseDate) ? (
                                                <span className="font-italic">Прием заявок закрыт</span>
                                            ) : (
                                                <Link to={`${nomination.id}`} className="btn btn-outline-primary">
                                                    Подать заявку
                                                </Link>
                                            )}
                                        </Col>
                                    </Row>
                                ))}
                            </Card.Body>
                        </Card>
                    ) : null
                )
            ) : (
                <h3>Нет данных</h3>
            )}
        </Container>
    );
}

export default NominationsPage;
